// Preço normal permanece no catálogo. As projeções abaixo são somente para exibição/configuração.
export function promocaoVigente(promocao: any, data: Date | null = new Date()): boolean {
  if (promocao?.ativa !== true || !data || !Number.isFinite(data.getTime())) return false;
  if ((promocao.diasSemana != null && !Array.isArray(promocao.diasSemana)) ||
    (promocao.horarios != null && !Array.isArray(promocao.horarios)) ||
    (promocao.diasSemana || []).some((dia: any) => !Number.isInteger(dia) || dia < 0 || dia > 6)) return false;
  for (const field of ['inicio', 'fim']) {
    if (!promocao[field]) continue;
    const limit = Date.parse(promocao[field]);
    if (!Number.isFinite(limit) || (field === 'inicio' ? data.getTime() < limit : data.getTime() > limit)) return false;
  }
  try {
    const parts = new Intl.DateTimeFormat('en-GB', { timeZone: promocao.fusoHorario || 'America/Sao_Paulo',
      year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit',
      hourCycle: 'h23' } as Intl.DateTimeFormatOptions).formatToParts(data);
    const fields: Record<string, string> = {};
    parts.forEach(part => { fields[part.type] = part.value; });
    const day = new Date(`${fields.year}-${fields.month}-${fields.day}T12:00:00Z`).getUTCDay();
    const time = `${fields.hour}:${fields.minute}`;
    const days = Array.isArray(promocao.diasSemana) ? promocao.diasSemana : [];
    const ranges = Array.isArray(promocao.horarios) ? promocao.horarios : [];
    const validDay = (value: number) => !days.length || days.includes(value);
    if (!ranges.length) return validDay(day);
    return ranges.some((range: any) => {
      if (!/^([01]\d|2[0-3]):[0-5]\d$/.test(range?.inicio) || !/^([01]\d|2[0-3]):[0-5]\d$/.test(range?.fim)) return false;
      const overnight = range.inicio > range.fim;
      const startDay = overnight && time <= range.fim ? (day + 6) % 7 : day;
      return validDay(startDay) && (overnight ? time >= range.inicio || time <= range.fim : time >= range.inicio && time <= range.fim);
    });
  } catch { return false; }
}

export function precoProdutoVigente(produto: any, data: Date | null = new Date()): any {
  const normal = produto?.valorNormalPromocao ?? produto?.valor;
  if (!promocaoVigente(produto?.promocao, data)) return normal;
  const raw = produto.promocao.valor;
  const text = String(raw ?? '').trim();
  const value = typeof raw === 'number' ? raw : Number(text.includes(',') ? text.replace(/\./g, '').replace(',', '.') : text);
  return raw !== '' && raw != null && Number.isFinite(value) && value >= 0 ? raw : normal;
}

export function produtoComPrecoVigente(produto: any, data: Date | null = new Date()): any {
  if (!produto) return produto;
  return { ...produto, ...(produto.promocao ? { valorNormalPromocao: produto.valorNormalPromocao ?? produto.valor,
    valor: precoProdutoVigente(produto, data) } : {}),
    ...(Array.isArray(produto.valores) ? { valores: produto.valores.map((valor: any) => produtoComPrecoVigente(valor, data)) } : {}),
    ...(Array.isArray(produto.grupoComplementos) ? { grupoComplementos: produto.grupoComplementos.map((grupo: any) => ({ ...grupo,
      itens: (grupo.itens || []).map((item: any) => !item.promocao ? item : { ...item,
        precoNormalPromocao: item.precoNormalPromocao ?? item.price,
        price: precoProdutoVigente({ valor: item.precoNormalPromocao ?? item.price, promocao: item.promocao }, data) }) })) } : {}) };
}

export function empresaComPrecosVigentes(empresa: any, data: Date | null = new Date()): any {
  return empresa ? { ...empresa, catalogoProdutos: (empresa.catalogoProdutos || []).map((produto: any) => produtoComPrecoVigente(produto, data)) } : empresa;
}
